import { render, staticRenderFns } from "./ModalVisualizarSaldo.vue?vue&type=template&id=05603de5&scoped=true&"
import script from "./ModalVisualizarSaldo.vue?vue&type=script&lang=js&"
export * from "./ModalVisualizarSaldo.vue?vue&type=script&lang=js&"
import style0 from "./ModalVisualizarSaldo.vue?vue&type=style&index=0&id=05603de5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05603de5",
  null
  
)

export default component.exports